import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';

import AvomaVariableTextInput from 'components/Common/AvomaVariableTextInput';

import { SMART_CATEGORY_EVENT } from 'constants/events';

const AutomationFormTaskTitle = ({
  action,
  handleValueChange,
  clientValue,
  selectedEvent,
  isEdit,
  isRequired = false,
  additionalDetails
}) => {
  const [selectedStaticVariable, setSelectedStaticVariable] = useState();
  const [variables, setVariables] = useState([]);
  const isInitialized = useRef(false);

  useEffect(() => {
    // Only initialize once, and skip if already initialized or in edit mode
    if (isInitialized.current || isEdit) {
      return;
    }
    // Add static variables to the start of the code
    if (!additionalDetails?.custom_category_key) {
      handleValueChange('');
      setVariables(action.optionChoices);
    } else {
      const smartCategoryVariable = {
        label: 'Each bullet point under smart topic',
        value: SMART_CATEGORY_EVENT
      };
      setSelectedStaticVariable(smartCategoryVariable);
      setVariables([...action.optionChoices, smartCategoryVariable]);
      // We only need to add the static variable during the create phase
      handleValueChange(`//${SMART_CATEGORY_EVENT}// `);
    }

    isInitialized.current = true;
  }, [additionalDetails, action.optionChoices, isEdit, handleValueChange]);

  // Separate effect to handle variables when additionalDetails or action.optionChoices change
  useEffect(() => {
    if (!additionalDetails?.custom_category_key) {
      setVariables(action.optionChoices);
    } else {
      const smartCategoryVariable = {
        label: 'Each bullet point under smart topic',
        value: SMART_CATEGORY_EVENT
      };
      setSelectedStaticVariable(smartCategoryVariable);
      setVariables([...action.optionChoices, smartCategoryVariable]);
    }
  }, [additionalDetails?.custom_category_key, action.optionChoices]);

  return (
    <div className='flex w-full flex-col gap-2'>
      <p className='flex items-center text-sm font-bold text-gunmetal'>
        {action.label} {isRequired && <span className='text-avoma-red'>*</span>}
      </p>
      <AvomaVariableTextInput
        placeholder={action.label}
        variables={variables}
        variableTitle={action.optionTitle}
        value={clientValue}
        onChange={handleValueChange}
        staticVariables={[selectedStaticVariable]}
        staticVariableClass='text-blue bg-blue-lightest'
      />
    </div>
  );
};

AutomationFormTaskTitle.propTypes = {
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    uid: PropTypes.string.isRequired,
    optionTitle: PropTypes.string.isRequired,
    optionChoices: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
      })
    ),
    apiUrl: PropTypes.string
  }),
  handleValueChange: PropTypes.func.isRequired,
  clientValue: PropTypes.string,
  selectedEvent: PropTypes.string,
  isEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  additionalDetails: PropTypes.shape({
    custom_category_key: PropTypes.string
  })
};

export default AutomationFormTaskTitle;
